/** True when MapLibre can read a finite center from `getCenter()`. */
export function finiteMapCenter(c: { lng: number; lat: number } | null | undefined): boolean {
  return !!c && Number.isFinite(c.lng) && Number.isFinite(c.lat);
}

/**
 * Run after the current synchronous stack and the next animation frame so MapLibre
 * camera APIs are not called re-entrantly from inside `_render` / `_update`.
 */
export function deferAfterMapFrame(run: () => void): void {
  queueMicrotask(() => {
    const raf = (globalThis as { requestAnimationFrame?: (fn: () => void) => number }).requestAnimationFrame;
    if (typeof raf === "function") raf(run);
    else setTimeout(run, 0);
  });
}
